import { API_ORIGIN } from '../config';

// Call for Quote. The login token is added to every API call by utils/apiAuth.
const API = `${API_ORIGIN}/api/cfq`;

async function call(path, options = {}) {
  const json = typeof options.body === 'string';
  const response = await fetch(`${API}${path}`, {
    ...options,
    headers: json ? { 'Content-Type': 'application/json' } : undefined,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.error || data.message || 'Something went wrong. Try again.');
  }
  return data;
}

const cfqService = {
  festivals: async () => (await call('/festivals')).festivals,
  /** { today, holidays: ['YYYY-MM-DD', ...] } */
  holidays: () => call('/holidays'),
  mine: async () => (await call('/mine')).requests,
  /** { year, years, requests } */
  register: (year) => call(`/register${year ? `?year=${year}` : ''}`),
  get: async (id) => (await call(`/${id}`)).request,
  create: async (values) => (await call('', { method: 'POST', body: JSON.stringify(values) })).request,
  cancel: async (id, reason) => (await call(`/${id}/cancel`, { method: 'POST', body: JSON.stringify({ reason }) })).request,
  /** { file_name, uploaded_at } or null */
  sop: async () => (await call('/sop')).sop,
  uploadSop: async (file) => {
    const body = new FormData();
    body.append('file', file);
    return (await call('/sop', { method: 'POST', body })).sop;
  },
  sopFileUrl: `${API}/sop/file`,
  /** period: { year } or { from, to } as YYYY-MM-DD */
  exportUrl: (period) => `${API}/register/export?${new URLSearchParams(period)}`,
};

export default cfqService;
